import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
import React, { useState} from 'react';
import { createPortal } from "react-dom";
export const Calendar = () =>{
    const [date,getDate]=useState([])
    const months = useState([
        {month : "Janvier",nbOfDay : 31},
        {month : "Février",nbOfDay : 28},// A changer pour les années bisextiles  
        {month : "Mars",nbOfDay : 31},  
        {month : "Avril",nbOfDay : 30},  
        {month : "Mai",nbOfDay : 31},  
        {month : "Juin",nbOfDay : 30},  
        {month : "Juillet",nbOfDay : 31},  
        {month : "Août",nbOfDay : 31},  
        {month : "Septembre",nbOfDay : 30},  
        {month : "Octobre",nbOfDay : 31},  
        {month : "Novembre",nbOfDay : 30},  
        {month : "Décembre",nbOfDay : 31}
    ])
    console.log(months[0][0].nbOfDay)

    const days = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"]
    let currentMonth = 0
    let currentNbOfDay = 0
    const calendarBig = []
    let currentDate = []
    let byMonth = []
    let numOfDay = 0
    let array =[]
    // Boucles par mois
   for(let i= 0;i < months[0].length;i++){
       currentMonth = i
       currentNbOfDay = months[0][i].nbOfDay
    // Boucle par jour
       for(let i = 1; i <= currentNbOfDay;i++){
        currentDate = new Date(new Date().getFullYear(),currentMonth,i)
       calendarBig.push([days[currentDate.getDay()],currentDate.getDate(),months[0][currentDate.getMonth()].month,currentDate.getFullYear()])
    }   
   } 
   let counter = 0
   // Boucle par mois
   for(let i= 0;i < months[0].length;i++){
        numOfDay = months[0][i].nbOfDay
        byMonth = calendarBig.slice(counter, counter+numOfDay)
        array.push(byMonth)
        counter = counter + numOfDay
   }
let test = array

console.log(array)
    return(
    
        <div id="articleContent" className="Calendar">
<a class="button only" target="_blank"   onClick={(event) => {window.print()} }>Imprimer ce calendrier</a>

        <p className="bigTitle">Future Log <span>{new Date().getFullYear()}</span></p>
       <div>

{array.map((item) => {
         return (
        <div className="blockMonth">
         <div className='titleMonth'>{item[0][2]}</div>
         <ul className="titleDay">
             <li>L</li>
             <li>M</li>
             <li>M</li>
             <li>J</li>
             <li>V</li>
             <li>S</li>
             <li>D</li>
         </ul>
         <ul className="days">
            {item[0][0]==="Lundi"? "": ""}
            {item[0][0]==="Mardi"? <li className='Mardi'></li>: ""}
            {item[0][0]==="Mercredi"?  <li className='Mercredi'></li>: ""}
            {item[0][0]==="Jeudi"?  <li className='Jeudi'></li>: ""}
            {item[0][0]==="Vendredi"?  <li className='Vendredi'></li>: ""}
            {item[0][0]==="Samedi"?  <li className='Samedi'></li>: ""}
            {item[0][0]==="Dimanche"?  <li className='Dimanche'></li>: ""}
         { 
                item.map((day) =>
                    
                <li>{day[1]}</li>)
            }


         </ul>
         <div className="space"></div>
         </div>
         )
        })}
        </div>
      </div>
    )
}
